// extracted by mini-css-extract-plugin
export default {"withTail":"Jjy8G1","direction-left":"kHJMdH","direction-right":"L3gsZu"};